import React from 'react';
import { DeleteOutlineTwoToneIcon } from 'tuui';
import { CONVERSION_STATUS } from 'modules/tracking/config/constants';
import { useConversionActions } from '../../hooks/useConversionActions';
import { ConversionTypeHeader } from '../ConversionTypeHeader/ConversionTypeHeader';
import styles from './reviewEventCard.module.scss';

export const ReviewEventCard = ({ event, setFocusedConversionId }) => {
    const { handleDeleteEvent } = useConversionActions();

    const handleMouseEnter = () => setFocusedConversionId(event.id);
    const handleMouseLeave = () => setFocusedConversionId(undefined);

    const isArchived = event.status === CONVERSION_STATUS.ARCHIVED;

    return (
        <div className={styles['inner']} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
            <div className={styles['header']}>
                <ConversionTypeHeader event={event} />
                {!isArchived && (
                    <div className={styles['delete-button']}>
                        <DeleteOutlineTwoToneIcon color="error" onClick={() => handleDeleteEvent(event.id)} />
                    </div>
                )}
            </div>
        </div>
    );
};
